export const buttonStyles = {
  backgroundColor: "#3498db",
  color: "white",
  fontSize: "20px",
  padding: "8px 10px",
  borderRadius: "5px",
  margin: "2px 8px 2px 8px",
  cursor: "pointer",
  transition: "background-color 0.3s ease-in-out",
  "&:hover": {
    backgroundColor: "lightblue",
  },
  border: "none",
  textShadow: "1px 1px 2px rgba(0, 0, 0, 0.5)",
};
